import { createSlice } from '@reduxjs/toolkit';

const inactivitySlice = createSlice({
  name: 'inactivity',
  initialState: {
    lastActivity: Date.now(),
    warningVisible: false,
  },
  reducers: {
    // Dispatched on throttled activity events AND when "I'm still here" is clicked.
    // Resets the inactivity clock and dismisses the warning if it was showing.
    recordActivity: (state) => {
      state.lastActivity = Date.now();
      state.warningVisible = false;
    },
    // Dispatched by useAutoLogout when 5 minutes of silence have elapsed.
    showWarning: (state) => {
      state.warningVisible = true;
    },
  },
});

export const { recordActivity, showWarning } = inactivitySlice.actions;
export default inactivitySlice.reducer;
